import React, { FC } from 'react';

import PaymentMethodSelect, { HoverTheme } from 'components/payment-method-select';
import Toggle from 'components/toggle';

import { ScanAndPayLayout } from './components/scan-and-pay-layout';
import NoPaymentMethod from './no-payment-method';
import { StyledSanityBlockContent } from './th-scan-and-pay.styled';
import { ITHScanAndPayViewProps, ScanAndPayViews } from './types';

export const THScanAndPayView: FC<ITHScanAndPayViewProps> = ({
  currentView,
  isLoading,
  scanAndPayTextContent,
  toggleScanAndPay,
  nonSelectedPaymentMethods,
  selectedPaymentMethod,
  addPaymentMethodButtonText,
  openAddPaymentMethodModal,
}) => {
  const ScanAndPayToggle = (
    <Toggle
      checked={currentView === ScanAndPayViews.ACTIVE}
      onChange={toggleScanAndPay}
      data-testid="scan-and-pay-toggle"
    />
  );

  if (isLoading) {
    // TODO: skeleton loader
    return <div data-testid="scan-and-pay-loader"></div>;
  }

  if (currentView === ScanAndPayViews.NO_PAYMENT_METHOD) {
    return (
      <NoPaymentMethod
        title={scanAndPayTextContent.header ?? ''}
        bodyText={scanAndPayTextContent.noPaymentMethodStateBody}
        addPaymentMethodButtonText={addPaymentMethodButtonText}
        openAddPaymentMethodModal={openAddPaymentMethodModal}
        data-testid="scan-and-pay-no-payment-method"
      />
    );
  }

  if (currentView === ScanAndPayViews.INACTIVE) {
    return (
      <ScanAndPayLayout
        data-testid="scan-and-pay-layout"
        title={scanAndPayTextContent.header ?? ''}
        headerElement={ScanAndPayToggle}
      >
        <StyledSanityBlockContent content={scanAndPayTextContent.inactiveStateBody} />
      </ScanAndPayLayout>
    );
  }

  return (
    <ScanAndPayLayout
      data-testid="scan-and-pay-active-state"
      title={scanAndPayTextContent.header ?? ''}
      headerElement={ScanAndPayToggle}
    >
      <PaymentMethodSelect
        selectedMethod={selectedPaymentMethod}
        nonSelectedMethods={nonSelectedPaymentMethods}
        onOptionClick={() => {}}
        hoverTheme={HoverTheme.LIGHT}
        onNavigateClick={openAddPaymentMethodModal}
      />
    </ScanAndPayLayout>
  );
};
